// extracted by mini-css-extract-plugin
module.exports = {"headline":"expressive-tile_headline__5Cszo","light":"expressive-tile_light__5fcyb","copyText":"expressive-tile_copyText__VBt9z"};